import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const ClubsService = {
  async getAll() {
    return safeRequest(
      apiClient.get("/clubs").then((response) => response.data),
    );
  },

  async create(payload) {
    return safeRequest(
      apiClient.post("/clubs", payload).then((response) => response.data),
    );
  },

  async getById(clubId) {
    return safeRequest(
      apiClient.get(`/clubs/${clubId}`).then((response) => response.data),
    );
  },
};
